import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetLabelParams } from '../../../../../services/param.service';
import { CasesGeneralInformationFilter } from '../../../../../shared/types/modules/cases-general-information';
import { asyncGetUsers } from '../../../../../services/users.service';

export const useCasesGeneralInformationFilters = (
    onFilter?: (data: CasesGeneralInformationFilter) => void
) => {
    const [typification1, setTypification1] = useState<ISelect[]>([]);
    const [typification2, setTypification2] = useState<ISelect[]>([]);
    const [typification3, setTypification3] = useState<ISelect[]>([]);
    const [typification4, setTypification4] = useState<ISelect[]>([]);
    const [typification5, setTypification5] = useState<ISelect[]>([]);
    const [users, setUsers] = useState<ISelect[]>([]);

    const onSubmit = (data: CasesGeneralInformationFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION1
        ).then((params) =>
            setTypification1(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION2
        ).then((params) =>
            setTypification2(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION3
        ).then((params) =>
            setTypification3(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION4
        ).then((params) =>
            setTypification4(params.map(({ name }) => ({ id: name, name })))
        );
        asyncGetLabelParams(
            ParamEnum.CASES_GENERAL_INFORMATION_TYPIFICATION5
        ).then((params) =>
            setTypification5(params.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    useEffect(() => {
        asyncGetUsers()
            .then((body: any) => {
                if (body && typeof body.items === 'object') {
                    setUsers(getDataUsers([body.items]));
                } else {
                    console.error('Not found data');
                }
            })
            .catch((error) => {
                console.error('Error al obtener usuarios:', error);
            })
            .finally(() => console.log('Cargando usuarios terminado'));
    }, []);

    function getDataUsers(users: any[]) {
        if (users.length > 0) {
            const usuarios = users[0].items;
            if (usuarios && usuarios.length > 0) {
                return usuarios.map((user: any) => ({
                    id: user.name,
                    name: user.name,
                }));
            } else {
                return [];
            }
        } else {
            return [];
        }
    }

    return {
        formik,
        typification1,
        typification2,
        typification3,
        typification4,
        typification5,
        users,
    };
};
